import { createMultiStepPlugin } from "@formkit/addons";
import { nl } from "@formkit/i18n";
import { genesisIcons } from "@formkit/icons";
import { createProPlugin, inputs } from "@formkit/pro";
import { defaultConfig, DefaultConfigOptions, plugin } from "@formkit/vue";
import { rootClasses } from "../../../formkit.theme";
import {
	addAsteriskToRequiredFields,
	autocompleteDisableLoadOnOpen,
	autocompleteOptionLoader,
	autocompleteOptionsLoader,
	datepickerAutoYear,
	passwordReveal,
} from "./plugins";
import enableClearSearchOnOpenAutocomplete from "./plugins/autocompleteClearSearchOnOpen";
import autocompleteGridSearch from "./plugins/autocompleteGridLookup";

const formkitPro = createProPlugin("fk-733de1be8fa", inputs);
const config: DefaultConfigOptions = defaultConfig({
	locales: { nl },
	locale: "nl",
	icons: genesisIcons,
	config: {
		rootClasses,
	},
	plugins: [
		formkitPro,
		addAsteriskToRequiredFields,
		autocompleteGridSearch,
		createMultiStepPlugin(),
		enableClearSearchOnOpenAutocomplete,
		autocompleteOptionLoader,
		autocompleteOptionsLoader,
		autocompleteDisableLoadOnOpen,
		datepickerAutoYear,
		passwordReveal,
	],
});

export { plugin as formKit, config as formKitConfig };
